import { useQuery } from "@tanstack/react-query";
import { ArchiveArchiveIndexSet } from "@graylog/enterprise-api";
import { defaultOnError } from "util/conditional/onError";
const getArchiveIndexSetConfiguration = async () => ArchiveArchiveIndexSet.indexSetConfig();
export const ARCHIVE_INDEX_SET_CONFIGURATION_QUERY_KEY = "archive_index_set_configuration";
const useArchiveIndexSetConfiguration = ({ enabled } = { enabled: true }) => {
  const { data, isLoading, refetch } = useQuery({
    queryKey: [ARCHIVE_INDEX_SET_CONFIGURATION_QUERY_KEY],
    queryFn: () => defaultOnError(
      getArchiveIndexSetConfiguration(),
      `Loading Archive Index Set Configuration failed with status`,
      `Could not load Archive Index Set Configuration`
    ),
    enabled
  });
  return {
    data,
    isLoading,
    refetch
  };
};
export default useArchiveIndexSetConfiguration;
